import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Plus } from "lucide-react";
import { useState } from "react";

function RenderRemoveCreditModal(props) {
  const [errorMessage, setErrorMessage] = useState("");

  const handleClose = () => {
    props.setShow(false);
    props.setRemoveCreditsValue(0);
    setErrorMessage("");
  };

  // Ensure availableCredits is always a number
  const availableCredits = Number(props.availableCredits) || 0;

  const handleCreditChange = (e) => {
    const value = e.target.value;
    if (value === "") {
      props.setRemoveCreditsValue(value);
      setErrorMessage("");
      return;
    }

    // Regex: numbers with optional decimal up to 2 places
    const regex = /^\d+(\.\d{0,2})?$/;

    if (regex.test(value)) {
      const numValue = parseFloat(value);
      if (numValue > availableCredits) {
        const creditsDisplay = availableCredits % 1 === 0 ? availableCredits : availableCredits.toFixed(2);
        setErrorMessage(`Cannot remove more than available credits (${creditsDisplay})`);
        props.setRemoveCreditsValue(value);
      } else {
        setErrorMessage("");
        props.setRemoveCreditsValue(value);
      }
    }
  };

  const handleConfirm = () => {
    const value = parseFloat(props.removeCreditsValue) || 0;
    if (value > availableCredits) {
      const creditsDisplay = availableCredits % 1 === 0 ? availableCredits : availableCredits.toFixed(2);
      setErrorMessage(`Cannot remove more than available credits (${creditsDisplay})`);
      return;
    }
    if (value <= 0) {
      setErrorMessage("Please enter a value greater than 0");
      return;
    }
    setErrorMessage("");
    props.setConfirmReduceUpdateCredit(true);
  };

  return (
    <>
      <style>
        {`
          .remove-credit-modal .modal-dialog {
            max-width: 420px !important;
          }
          .remove-credit-modal .modal-content {
            border-radius: 14px !important;
            overflow: hidden;
            box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;
          }
          .remove-credit-modal .modal-header {
            background: linear-gradient(135deg, #1e2a55, #2f4b8f) !important;
            color: white !important;
            border-bottom: none !important;
            border-radius: 14px 14px 0 0 !important;
            padding: 18px 24px !important;
          }
          .remove-credit-modal .modal-title {
            color: white !important;
            font-size: 20px !important;
            font-weight: 600 !important;
            letter-spacing: 0.3px !important;
            margin: 0 !important;
          }
          .remove-credit-modal .btn-close {
            filter: brightness(0) invert(1) !important;
            opacity: 0.8 !important;
            font-size: 20px !important;
            transition: opacity 0.2s !important;
          }
          .remove-credit-modal .btn-close:hover {
            opacity: 1 !important;
          }
          .remove-credit-modal .modal-body {
            padding: 24px !important;
          }
        `}
      </style>
      <Modal 
        show={props.show} 
        onHide={handleClose} 
        centered
        dialogClassName="remove-credit-modal"
      >
        <Modal.Header>
          <Modal.Title>{props?.title ? props?.title : "Remove Voice Credits"}</Modal.Title>
          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={handleClose}
            aria-label="Close"
          />
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div style={{ 
              marginBottom: "16px", 
              padding: "12px", 
              backgroundColor: "#f0f9ff", 
              borderRadius: "8px",
              border: "1px solid #bae6fd"
            }}>
              <div style={{ 
                fontSize: "14px", 
                color: "#0369a1", 
                fontWeight: "500",
                marginBottom: "4px"
              }}>
                Available Credits:
              </div>
              <div style={{ 
                fontSize: "20px", 
                color: "#0c4a6e", 
                fontWeight: "600"
              }}>
                {availableCredits % 1 === 0 ? availableCredits : availableCredits.toFixed(2)}
              </div>
            </div>
            <Form.Group controlId="creditValue">
              <Form.Label style={{ 
                fontSize: "14px", 
                fontWeight: "500", 
                marginBottom: "8px",
                color: "#374151"
              }}>
                Amount to Remove:
              </Form.Label>
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <Form.Control
                  type="number"
                  value={props.removeCreditsValue}
                  onChange={handleCreditChange}
                  onBlur={(e) => {
                    const value = parseFloat(e.target.value) || 0;
                    if (value > availableCredits) {
                      const creditsDisplay = availableCredits % 1 === 0 ? availableCredits : availableCredits.toFixed(2);
                      setErrorMessage(`Cannot remove more than available credits (${creditsDisplay})`);
                    } else if (value <= 0 && e.target.value !== "") {
                      setErrorMessage("Please enter a value greater than 0");
                    } else {
                      setErrorMessage("");
                    }
                  }}
                  placeholder="0"
                  min="0"
                  max={availableCredits}
                  step="0.01"
                  style={{
                    borderRadius: "8px 0 0 8px",
                    borderRight: "none",
                    backgroundColor: "#f9fafb",
                    padding: "8px 12px",
                    fontSize: "16px",
                    borderColor: errorMessage ? "#ef4444" : "#d1d5db"
                  }}
                />
                <button
                  type="button"
                  onClick={() => {
                    const currentValue = parseFloat(props.removeCreditsValue) || 0;
                    const newValue = currentValue + 1;
                    if (newValue > availableCredits) {
                      const creditsDisplay = availableCredits % 1 === 0 ? availableCredits : availableCredits.toFixed(2);
                      setErrorMessage(`Cannot remove more than available credits (${creditsDisplay})`);
                      const maxValue = availableCredits % 1 === 0 ? availableCredits.toString() : availableCredits.toFixed(2);
                      props.setRemoveCreditsValue(maxValue);
                    } else {
                      setErrorMessage("");
                      props.setRemoveCreditsValue(newValue.toString());
                    }
                  }}
                  style={{
                    backgroundColor: "#4f6edb",
                    border: "none",
                    borderRadius: "0 8px 8px 0",
                    padding: "8px 12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    color: "white",
                    minWidth: "45px",
                    transition: "background-color 0.2s"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#3b5ccc";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#4f6edb";
                  }}
                >
                  <Plus size={20} />
                </button>
              </div>
              {errorMessage && (
                <div style={{
                  color: "#ef4444",
                  fontSize: "13px",
                  marginTop: "8px",
                  padding: "6px 8px",
                  backgroundColor: "#fef2f2",
                  borderRadius: "6px",
                  border: "1px solid #fecaca"
                }}>
                  {errorMessage}
                </div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <div style={{
          backgroundColor: "white",
          borderTop: "1px solid #e5e7eb",
          padding: "16px 24px",
          marginTop: "0",
          borderRadius: "0 0 14px 14px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px"
        }}>
          <Button 
            variant="secondary" 
            onClick={handleClose}
            style={{
              padding: "8px 22px",
              border: "none",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "500",
              backgroundColor: "#6c757d",
              borderColor: "#6c757d"
            }}
          >
            Close
          </Button>
          <Button 
            onClick={handleConfirm}
            disabled={!!errorMessage || !props.removeCreditsValue || parseFloat(props.removeCreditsValue) <= 0}
            style={{
              padding: "8px 22px",
              border: "none",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "500",
              color: "white",
              background: errorMessage || !props.removeCreditsValue || parseFloat(props.removeCreditsValue) <= 0
                ? "linear-gradient(135deg, #9ca3af, #6b7280)"
                : "linear-gradient(135deg, #4f6edb, #3b5ccc)",
              boxShadow: errorMessage || !props.removeCreditsValue || parseFloat(props.removeCreditsValue) <= 0
                ? "none"
                : "0 8px 18px rgba(79,110,219,0.35)",
              transition: "all 0.2s",
              cursor: errorMessage || !props.removeCreditsValue || parseFloat(props.removeCreditsValue) <= 0
                ? "not-allowed"
                : "pointer",
              opacity: errorMessage || !props.removeCreditsValue || parseFloat(props.removeCreditsValue) <= 0 ? 0.6 : 1
            }}
            onMouseEnter={(e) => {
              if (!errorMessage && props.removeCreditsValue && parseFloat(props.removeCreditsValue) > 0) {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 12px 22px rgba(79,110,219,0.45)";
              }
            }}
            onMouseLeave={(e) => {
              if (!errorMessage && props.removeCreditsValue && parseFloat(props.removeCreditsValue) > 0) {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 8px 18px rgba(79,110,219,0.35)";
              }
            }}
          >
            Confirm
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default RenderRemoveCreditModal;
